import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';



const COLORS = [
    '#3363FF', // Royal Blue
    '#33B0FF', // Sky Blue
    '#33FFAA', // Light Green
    '#33FFCC', // Cyan
    '#33E7FF', // Light Blue
    '#FFBD33', // Yellow
    '#FF5733', // Dark Orange
    '#FFC733', // Mustard Yellow
    '#FFE333', // Light Yellow
    '#33FF33', // Lime Green
    '#33A0FF', // Azure
    '#33FF6F', // Sea Green
    '#FF33A8', // Pinkish Purple
    '#33C5FF', // Teal
    '#FFA933', // Orange
    '#FF33D7', // Magenta
    '#33FF4C', // Spring Green
    '#FF33F5', // Fuchsia
];



function groupedAndSortedData(data) {
    console.log("Date wise group data",data);
    let d =  data.reduce((groups, item) => {
        const date = item.date;
        let group = groups.find((group) => group[0].date === date);

        if (!group) {
            group = [];
            groups.push(group);
        }

        group.push(item);

        return groups;
    }, []);

    d.sort((a, b) => {
        const dateA = a[0].date;
        const dateB = b[0].date;
        return dateA.localeCompare(dateB); // Sort in ascending order
    });
    console.log("Date wise group data final",d);

    return d;

}


export default function DatewiseChart({ data }) {

    let isSmallScreen = useMediaQuery('(max-width: 800px)');

    let [hidden, setHidden] = useState([]);

    if (!data) return;

    if (isSmallScreen) return null;

    let grouped = groupedAndSortedData(data);

    let contestants = [];

    let chartData = grouped.map((g, index) => {
        let o = {};
        o.date = g[0].date;
        g = g.filter(i => !!i.contestant);
        for(let i of g) {
            
            o[i.contestant] = i.count;

            if(index === 0) {
                contestants.push(i.contestant);
            }
        }
        return o;
    });

    console.log('cd', chartData);

    function handleLegendItemClick(c) {
        if(hidden.includes(c)) {
            let h = hidden.filter(cur => cur !== c);
            setHidden(h);
        } else {
            setHidden([...hidden, c]);
        }
    }

    return (
        <ResponsiveContainer width="100%" height="90%">
            <LineChart
                width={300}
                height={100}
                data={chartData}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="20 20" />
                <XAxis dataKey="date" angle={-45}/>
                <YAxis />
                <Tooltip />
                <Legend onClick={(item) => handleLegendItemClick(item.value)} wrapperStyle={{bottom: '-20px'}}/>
                {
                    contestants.map((c, index) => {

                        let hide = hidden.includes(c);

                        return <Line type="monotone" key={c} dataKey={c} stroke={COLORS[index % COLORS.length]} hide={hide}/>
                    })
                }
            </LineChart>
        </ResponsiveContainer>
    );
}